import React, { useState } from 'react';
import Image, { StaticImageData } from 'next/image';
import shim from './shimmer';

// istanbul ignore next
const toBase64 = (str: string) =>
  typeof window === 'undefined' ? Buffer.from(str).toString('base64') : window.btoa(str);

interface ImageProps {
  type?: 'static' | 'dynamic';
  src?: string | StaticImageData;
  fallbackSrc?: string | StaticImageData;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  loading?: 'lazy' | 'eager';
  priority?: boolean | undefined;
}

const ImageWithFallback = (props: ImageProps) => {
  const { type = 'static', src, fallbackSrc, height, width, alt, priority, ...rest } = props;
  const [imgSrc, setImgSrc] = useState(src || fallbackSrc || '');
  if (type === 'static') {
    return (
      <Image {...rest} alt={alt} src={imgSrc} height={height} width={width} priority={priority} />
    );
  }
  return (
    <Image
      {...rest}
      alt={alt}
      src={imgSrc}
      placeholder="blur"
      blurDataURL={`data:image/svg+xml;base64,${toBase64(shim(width, height))}`}
      height={height}
      width={width}
      priority={priority}
      onError={() => {
        setImgSrc('/images/productPlaceholder.svg');
      }}
    />
  );
};

export default ImageWithFallback;
